import { Component, inject } from '@angular/core';

import { LoginRedirectComponent } from '@camelot/user';

import { VisitorTokenService } from 'src/app/auth/visitor-token.service';

@Component({
  template: '',
})
export class LoginPage extends LoginRedirectComponent {
  private readonly _visitorTokenService = inject(VisitorTokenService);

  constructor() {
    super();

    this._visitorTokenService.close();
  }
}
